import React from 'react'
import DateView from 'react-datepicker'
import { Field, ErrorMessage } from 'formik'
import TextError from './TextError'
import 'react-datepicker/dist/react-datepicker.css'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

function DatePicker(props) {
  const { label, name, showDropdownIcon, ...rest } = props
  return (
    <div className='mb-2'>
      {label && <label className=' mb-2 block ' htmlFor={name}>{label}</label>}
      <Field name={name}>
        {({ form, field }) => {
          const { setFieldValue } = form
          const { value } = field
          return (
            <div className='relative w-full'>
              <DateView
                className=' w-full rounded-lg border p-4 bg-[#FAFBFC] border-gray-200'
                id={name}
                {...field}
                {...rest}
                selected={value}
                onChange={val => setFieldValue(name, val)}
              />
              {showDropdownIcon && (
                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-500">
                  <KeyboardArrowDownIcon />
                </div>
              )}
            </div>
          )
        }}
      </Field>
      <ErrorMessage component={TextError} name={name} />
    </div>
  )
}

export default DatePicker
